import InputFieldSet from "PFComponents/text/input_field_set";
import useForceUpdate from "PFCore/helpers/use_force_update";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import css from "./overwrites.module.scss";
import ResetButton from "./reset_button";

const MainJobTitle = ({ exportableProfile }) => {
  const { t } = useTranslation();

  const forceUpdate = useForceUpdate();
  const [hasChanged, setHasChanged] = useState(false);

  useEffect(() => {
    setHasChanged(exportableProfile.hasChangedMainJobTitle());
  }, [exportableProfile.hasChangedMainJobTitle()]);

  return (
    <div className={css.flexRow}>
      <InputFieldSet
        controlledValue
        label={t("export.edit.jobTitle")}
        value={exportableProfile.mainJobTitle || ""}
        handleChange={(val) => {
          exportableProfile.setMainJobTitle(val);
          setHasChanged(val);
        }}
        style={{ width: "97%" }}
      />

      <div className={css.resetLabel}>
        {hasChanged && (
          <ResetButton
            onClick={() => {
              exportableProfile.resetMainJobTitle();
              setHasChanged(false);
              forceUpdate();
            }}
          />
        )}
      </div>
    </div>
  );
};

MainJobTitle.propTypes = {
  exportableProfile: PropTypes.object.isRequired
};

export default MainJobTitle;
